// Initialize flickity slider for collection list slider 

let sliders = document.querySelectorAll('.collection-slider__slider-images');
sliders.forEach(function (slider) {
  var flkty = new Flickity(slider, {
    "contain": true,
    "cellAlign": "left",
    "pageDots": false,
    "prevNextButtons": true,
    "groupCells": true
  });
});